/* eslint-disable no-prototype-builtins */
/* eslint-disable no-use-before-define */
/* eslint-disable react/no-danger */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  FaInfoCircle,
  FaLock,
  FaMinusCircle,
  FaSearch,
  FaTimesCircle,
} from 'react-icons/fa';
import SelectSearch, { fuzzySearch } from 'react-select-search';
import HR from '../../../../components/hr';
import Input from '../../../../components/input';
import Spacer from '../../../../components/spacer';
import H4 from '../../../../components/h4';
import InnerRadio from '../../../../components/innerRadio';
import ApiErrorMessage from '../../../../components/apiErrorMessage';
import AppState from '../../../../store/appstate';
import {
  getMyAccount,
  getMySong,
  getMySongs,
  getMySongsDetailedPaginated,
  getMyWriters,
  getTheme,
  whoAmI,
} from '../../../../api/queries';
import {
  createRecording,
  createSong,
  updateRecordingMeta,
  updateSong,
} from '../../../../api/mutations';
import MultipleInput from '../../../../components/multipleInput';
import ButtonLink from '../../../../components/buttonLink';
import WritersForm from '../writers/writersForm';
import LoadingSmall from '../../../../components/loadingSmall';
import P from '../../../../components/p';
import {
  nameRegexTest,
  sendEvent,
  sendProperty,
  strToBool,
  titleRegexTest,
} from '../../../../helpers/helpers';
import H1 from '../../../../components/h1';
import ButtonPrimaryText from '../../../../components/buttonPrimaryText';
import Select from '../../../../components/select';
import ButtonPrimary from '../../../../components/buttonPrimary';
import SongWriterSplitCreate from './SongWriterSplitCreate';
import ButtonPrimaryLarge from '../../../../components/buttonPrimaryLarge';

function SongsCreateUpdate({
  id, closeModal, spotifySuggestion = null, onComplete = () => { }, aac = null,
}) {
  const [reset, setReset] = useState(0);
  const isUpdate = !!id;
  const { t } = useTranslation('songs');
  const [title, setTitle] = useState();
  const [durationmins, setDurationmins] = useState();
  const [durationsecs, setDurationsecs] = useState();
  const [isremix, setIsremix] = useState('false');
  const [containssamples, setContainssamples] = useState('false');
  const [performers, setPerformers] = useState();
  const [alternativetitles, setAlternativetitles] = useState();
  const [songWriters, setSongWriters] = useState([]);
  const [verifiedState, setVerifiedState] = useState(null);
  const [version, setVersion] = useState(null);
  const [isLocked, setIsLocked] = useState(false);
  const [writerModal, setWriterModal] = useState(false);
  const [performingartist, setPerformingartist] = useState();
  const [isrc, setIsrc] = useState();
  const [releasedate, setReleasedate] = useState();
  const [pending, setPending] = useState(false);
  const [selectedWriter, setSelectedWriter] = useState(null);

  const [spotifySongIdentifier, setSpotifySongIdentifier] = useState(null);
  const [spotifyPopularity, setSpotifyPopularity] = useState(null);

  // eslint-disable-next-line no-unused-vars
  const [apiError, setApiError] = useState('');
  const [errors, setErrors] = useState({});
  const history = useHistory();
  const createMutation = createSong();
  const updateMutation = updateSong();
  const recordingCreateMutation = createRecording();
  const recordingMetaMutation = updateRecordingMeta();

  let selectedAccount = null;
  if (aac) {
    selectedAccount = aac;
  } else {
    selectedAccount = AppState.useState((s) => s.selectedAccount);
  }
  const tableState = AppState.useState((s) => s.songsTable);
  const songs = getMySongsDetailedPaginated({
    aac: selectedAccount, perPage: tableState.perPage, page: tableState.page, sortBy: tableState.sortBy?.[0]?.id, desc: tableState.sortBy?.[0]?.desc, globalFilter: tableState.globalFilter,
  });
  const song = getMySong({ aac: selectedAccount, wc: id });

  const [justAddedWorkCode, setJustAddedWorkCode] = useState(null);
  const songJustAdded = getMySong({
    aac: selectedAccount,
    wc: justAddedWorkCode,
  });

  const who = whoAmI();

  const writers = getMyWriters({ aac: selectedAccount });

  const [spotifyResult, setSpotifyResult] = useState();
  const [agreeAddRecording, setAgreeAddRecording] = useState(true);

  const [apiToken, setAPIToken] = useState(null);

  const getSpotifyAPIToken = async () => {
    const apiUrl = process.env.REACT_APP_API;

    const response = await fetch(`${apiUrl}/spotify-token`);
    const responseData = await response.json();
    return responseData.access_token;
  };

  useEffect(() => {
    async function go() {
      setAPIToken(await getSpotifyAPIToken());
    }
    go();
  }, []);

  useEffect(() => {
    if (selectedAccount) {
      writers.refetch();
      song.refetch();
    }
  }, [selectedAccount]);

  if ((song.isError || song.data === null) && isUpdate) {
    history.push('/songs');
  }

  // if song just added, then also add recording
  useEffect(() => {
    if (songJustAdded?.data) {
      addRecording();
    }
  }, [songJustAdded.data]);

  if (song.isSuccess && id && !title) {
    setVerifiedState(song.data.verifiedstate);
    setVersion(song.data.version);
    setIsLocked(song.data.islocked);
    setTitle(song.data.title);
    setDurationmins(song.data.durationmins);
    setDurationsecs(song.data.durationsecs);
    setIsremix(song.data.isremix ? 'true' : 'false');
    setContainssamples(song.data.containssamples ? 'true' : 'false');
    setPerformers(
      song.data.performingartists
        .map((a) => ({
          ...a,
          name: a.performingartistname,
        }))
        .filter((p) => !p.isdeleted),
    );
    setAlternativetitles(
      song.data?.alternativetitles.filter((p) => !p.isdeleted),
    );
    setSongWriters(
      song.data.writersplits.map((w) => ({
        ...w,
        righttocollect: w.righttocollect ? 'true' : 'false',
      })),
    );
  }

  if (spotifySuggestion && !title) {
    const tr = spotifySuggestion;

    setTitle(tr.title);
    setDurationmins(
      Math.floor(tr.duration / 1000 / 60),
    );
    setDurationsecs(
      Math.floor((tr.duration / 1000) % 60),
    );
    setPerformers(
      tr.artists.split(',').map((a) => ({
        name: a.replace(/&#44;/g, ','),
      })),
    );
    const date = tr?.release_date?.length === 4 ? `${tr.release_date}-01-01` : tr?.release_date;
    setReset(reset + 1);
    setPerformingartist(tr.artists.split(',')[0]);
    setIsrc(tr?.isrc);
    setSpotifyResult(tr);
    setSpotifySongIdentifier(tr?.spotify_song_id);
    setSpotifyPopularity(tr?.popularity);
    setReleasedate(date);
    setAgreeAddRecording(true);
  }

  const checkErrors = (field) => {
    let errs = {};
    if (field) {
      errs = JSON.parse(JSON.stringify(errors));
      delete errs[field];
    }

    let valid = true;
    // title check

    if (!field || field === 'title') {
      const validTitle = title?.trim().length > 0;
      if (!validTitle) {
        errs.title = t('regex:song-title-regex');
        valid = false;
      }

      if (title && !titleRegexTest(title)) {
        errs.title = t('regex:invalid-characters');
        valid = false;
      }
    }

    if (!field || field === 'alternativetitles') {
      if (alternativetitles) {
        alternativetitles.forEach((p) => {
          if (!p?.title || p.title.trim().length < 1) {
            errs.alternativetitles = t('regex:song-alternative-title-regex');
            valid = false;
          } else if (p.title && !titleRegexTest(p.title)) {
            errs.alternativetitles = t('regex:invalid-characters');
            valid = false;
          }
        });
      }
    }

    if (!field || field === 'performers') {
      // has at least one performer
      if (!performers || performers.length < 1) {
        errs.performers = t('regex:song-performer-regex');
        valid = false;
      }

      // check valid performer names
      if (performers) {
        performers.forEach((p) => {
          if (!p?.name || p.name.trim().length < 1) {
            errs.performers = t('regex:song-performer-name-regex');
            valid = false;
          } else if (p.name.length > 44) {
            errs.performers = t('regex:song-performer-max-length-regex');
            valid = false;
          } else if (p.name && !nameRegexTest(p.name)) {
            errs.performers = t('regex:invalid-characters2');
            valid = false;
          }
        });
      }
    }
    if (!field || field === 'writers') {
      if (!songWriters && !field) {
        errs.writers = t('regex:add-songwriter-regex');
        valid = false;
      }

      if (songWriters) {
        let total = 0;
        let fieldError = false;
        songWriters.forEach((p) => {
          if (
            !field
            && (!p?.writercode
              || !p?.righttocollect
              || !p?.writershare
              || !p?.writerdesignationcode)
          ) {
            errs.writers = t('regex:select-a-writer-regex');
            valid = false;
            fieldError = true;
          } else if (p.writershare) {
            total += Number(p.writershare);

            total = Number(total.toFixed(2));

            if (p.writershare.toString().indexOf('.') > -1) {
              const decimalLength = p.writershare.toString().length
                - (p.writershare.toString().indexOf('.') + 1);
              if (decimalLength > 2) {
                errs.writers = t('regex:writer-splits-regex');
                valid = false;
              }
            }
          } else {
            fieldError = true;
          }
        });
        if (total !== 100 && !fieldError) {
          errs.writers = t('regex:writer-share-regex');
          valid = false;
        }
      }
      if (songWriters) {
        let atLeastOneRightToCollect = false;
        songWriters.forEach((p) => {
          if (strToBool(p.righttocollect)) {
            atLeastOneRightToCollect = true;
          }
        });

        if (!atLeastOneRightToCollect) {
          errs.writers = t('regex:writer-right-to-collect-regex');
          valid = false;
        }
      }
    }

    setErrors(errs);
    return valid;
  };

  function renderFriend(props, option, snapshot, className) {
    return (
      <button type="button" {...props} className={className}>
        <div className="flex flex-row items-center w-full">
          {option.photo && (
            <img
              className="w-10 h-10 object-cover mr-4 rounded-full"
              alt={option.name}
              src={option.photo}
            />
          )}
          {!option.photo && (
            <div className="w-12 h-12 bg-gray-300 rounded-full mr-4" />
          )}
          <h4>{option.name}</h4>
        </div>
      </button>
    );
  }

  function addSongSuccess() {
    toast.success(`${t('songs:song-added-toast')}: ${title}`, {
      position: 'bottom-right',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    sendProperty({ property: 'last_song_added', value: 'CURRENT_DATE', email: who?.data?.email });
    sendEvent({ property: 'pe14489857_last_song_added' });

    songs.refetch();
    history.push('/songs');
    setPending(false);
  }

  function validationFailed(message) {
    if (
      message.toString().includes('There is an existing record, Work code(s)')
    ) {
      setApiError('This song has already been added.');
    } else {
      setApiError(message);
    }
    setPending(false);
  }

  const addSong = async () => {
    setPending(true);
    setApiError('');
    // reset mutation
    createMutation.reset();
    const valid = checkErrors();

    if (valid) {
      let alts = [];
      if (alternativetitles) {
        alts = alternativetitles.filter((a) => a.title.length > 0);
      }

      const data = {
        artistaccountcode: selectedAccount,
        title,
        durationmins,
        durationsecs,
        isremix: isremix === 'true',
        containssamples: containssamples === 'true',
        ispublicdomain: true,
        alternativetitles: alts,
        performingartistnames: performers,
        writersplits: songWriters
          ? songWriters.map((w) => ({
            ...w,
            righttocollect: strToBool(w.righttocollect),
          }))
          : [],
      };

      createMutation.mutate(data, {
        onSuccess: (response) => {
          console.log('a', response);
          // Check for 4xx validation errors
          if (response.validationMessage) {
            validationFailed(response.validationMessage);
          } else if (spotifyResult && agreeAddRecording === true) {
            setJustAddedWorkCode(response.model.workcode);
          } else {
            addSongSuccess();
          }
        },
        onError: (error) => {
          setApiError(error.message || 'Unknown error occurred.');
          setPending(false);
        },
      });
    }
    setPending(false);
  };

  const update = async () => {
    setPending(true);
    setApiError('');
    // reset mutation
    updateMutation.reset();
    const valid = checkErrors();
    if (valid) {
      let alts = [];
      if (alternativetitles) {
        alts = alternativetitles.filter((a) => a.title.length > 0);
      }

      alts = alts.map((a) => ({
        title: a.title,
        alternativetitleidentifier: a.hasOwnProperty('alternativetitleidentifier') ? a.alternativetitleidentifier : '00000000-0000-0000-0000-000000000000',
        alternativetitleamendmentidentifier: a.hasOwnProperty('alternativetitleamendmentidentifier') ? a.alternativetitleamendmentidentifier : '00000000-0000-0000-0000-000000000000',

      }));

      const performersNew = performers.map((a) => ({
        performingartistname: a.name,
        performingartistidentifier: a.hasOwnProperty('performingartistidentifier') ? a.performingartistidentifier : '00000000-0000-0000-0000-000000000000',
        performingartistamendmentidentifier: a.hasOwnProperty('performingartistamendmentidentifier') ? a.performingartistamendmentidentifier : '00000000-0000-0000-0000-000000000000',

      }));

      const writersplitsNew = songWriters.map((a) => ({
        writercode: a.writercode,
        writershare: a.writershare,
        writerdesignationcode: a.writerdesignationcode,
        righttocollect: strToBool(a.righttocollect),
        writersplitamendmentidentifier: a.hasOwnProperty('writersplitamendmentidentifier') ? a.writersplitamendmentidentifier : '00000000-0000-0000-0000-000000000000',
        writersplitidentifier: a.hasOwnProperty('writersplitidentifier') ? a.writersplitidentifier : '00000000-0000-0000-0000-000000000000',

      }));

      const data = {
        artistaccountcode: selectedAccount,
        title,
        durationmins,
        durationsecs,
        isremix: isremix === 'true',
        containssamples: containssamples === 'true',
        ispublicdomain: true,
        alternativetitles: alts,
        performingartistnames: performersNew,
        writersplits: writersplitsNew,
        workcode: song.data.workcode,
        etag: song.data.etag,
        iswc: song.data.iswc,
      };

      updateMutation.mutate(data, {
        onSuccess: (result) => {
          if (result.validationMessage) {
            setApiError(result.validationMessage);
            setPending(false);
          } else {
            toast.success(`${t('songs:song-updated-toast')}: ${title}`, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            song.refetch();
            songs.refetch();
            if (isUpdate) {
              closeModal();
            } else {
              history.push('/songs');
            }
            setPending(false);
          }
        },
        onError: (error) => {
          setApiError(error.message);
          setPending(false);
        },
      });
      setPending(false);
    } else {
      setPending(false);
    }
  };

  const addRecording = async () => {
    setPending(true);
    setApiError('');
    // reset mutation
    recordingCreateMutation.reset();
    const valid = checkErrors();
    if (valid) {
      const data = {
        artistaccountcode: selectedAccount,
        title,
        performingartist,
        isrc,
        releasedate,
        workcode: songJustAdded.data.workcode,
        spotifyidentifier: spotifySongIdentifier === undefined || spotifySongIdentifier == null ? null : spotifySongIdentifier,
        spotifypopularity: spotifySongIdentifier === undefined || spotifySongIdentifier == null ? null : spotifyPopularity,
        spotifypopularitylastupdatedutc: spotifySongIdentifier === undefined || spotifySongIdentifier == null ? null : new Date().toISOString(),
        etag: songJustAdded.data.etag,
      };

      recordingCreateMutation.mutate(data, {
        onSuccess: (result) => {
          addRecordingMeta(result.model.recordingidentifier, null);
          addSongSuccess();
        },
        onError: (error) => {
          setApiError(error.message);
          setPending(false);
        },
      });
    } else {
      setPending(false);
    }
  };

  const addRecordingMeta = (rid, mp3url = null) => {
    recordingMetaMutation.reset();
    let data = {};

    if (spotifySuggestion) {
      data = {
        id: rid,
        spotify_id: spotifySuggestion.spotify_song_id,
        mp3: mp3url,
        thumb_url: spotifySuggestion?.images ? JSON.parse(spotifySuggestion?.images)?.[0].url : null,
        song_id: songJustAdded.data.workcode,
      };
    } else {
      data = {
        id: rid,
        spotify_id: spotifyResult ? spotifyResult.id : null,
        mp3: mp3url,
        thumb_url: spotifyResult ? spotifyResult?.album?.images[0].url : null,
        song_id: songJustAdded.data.workcode,

      };
    }

    recordingMetaMutation.mutate(data, {
      onSuccess: () => {
        toast.success(`${t('songs:song-updated-toast')}: ${title}`, {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        sendProperty({ property: 'last_recording_added', value: 'CURRENT_DATE', email: who?.data?.email });
        sendEvent({ property: 'pe14489857_recording_added' });

        songs.refetch();
        if (spotifySuggestion) {
          onComplete();
        } else {
          history.push('/songs');
        }
        setPending(false);
      },
      onError: (error) => {
        // setApiError(error.message);
        setPending(false);
      },
    });
  };

  const removeSpotify = () => {
    setTitle('');
    setDurationmins('');
    setDurationsecs('');
    setPerformers(null);
    setAlternativetitles(null);
    setPerformingartist('');
    setIsrc(null);
    setReleasedate(null);
    setSpotifySongIdentifier(null);
    setSpotifyPopularity(null);
    setSpotifyResult(null);
    setReset(reset + 1);
  };

  const setWriterField = ({ writercode, field, value }) => {
    const writerArray = songWriters.slice();
    const item = writerArray.find((w) => w.writercode === writercode);
    if (field === 'righttocollect') {
      item.righttocollect = strToBool(item.righttocollect) ? 'false' : 'true';
    } else {
      item[field] = value;
    }

    setSongWriters(writerArray);
  };

  const shareSplitsEqually = () => {
    const numberWriters = songWriters.length;
    const sWriters = songWriters.slice();
    if (numberWriters > 0) {
      const share = (100 / numberWriters).toFixed(2);
      sWriters.forEach((s, i) => {
        s.writershare = share;
        // set last writer slightly higher incase odd number
        if (i === (numberWriters - 1)) {
          s.writershare = (100 - i * share).toFixed(2);
        }
      });

      setSongWriters(sWriters);
    }
  };

  const deleteSongWriter = (writercode) => {
    let sWriters = songWriters.slice();
    sWriters = sWriters.filter((s) => s.writercode !== writercode);
    setSongWriters(sWriters);
  };

  let writerSplitsPercentage = 0;
  songWriters.forEach((s) => {
    if (s.writershare && !s.isdeleted) {
      writerSplitsPercentage += Number(s.writershare);
    }
  });

  writerSplitsPercentage = writerSplitsPercentage.toFixed(2);

  const handleChangeSearchForRecords = (track) => {
    const tr = JSON.parse(track);
    const date = tr.album.release_date?.length === 4 ? `${tr.album.release_date}-01-01` : tr.album.release_date;
    setTitle(tr.name);
    setDurationmins(
      Math.floor(tr.duration_ms / 1000 / 60),
    );
    setDurationsecs(
      Math.floor((tr.duration_ms / 1000) % 60),
    );
    setPerformers(
      tr.artists.map((a) => ({
        name: a.name,
      })),
    );
    setReset(reset + 1);
    setPerformingartist(tr.artists[0].name);
    setIsrc(tr?.external_ids?.isrc);
    setReleasedate(date);
    setSpotifySongIdentifier(tr.id); // should be 'spotify_song_id' but for some reason, this is the primary key, it's the spotify song id
    setSpotifyPopularity(tr.popularity);
    setSpotifyResult(tr);
    setApiError('');
  };

  const getOptionsOfRecords = (query) => new Promise((resolve, reject) => {
    if (!query) {
      resolve([]);
      return;
    }
    fetch(
      `https://api.spotify.com/v1/search?q=${query}&type=track&market=GB&limit=50`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiToken}`,
        },
      },
    )
      .then((response) => response.json())
      .then(({ tracks }) => {
        resolve(
          tracks.items.map((track) => ({
            value: JSON.stringify(track),
            name: `${track.name} - ${track.artists[0].name}`,
            photo:
              track.album
                && track.album.images
                && track.album.images.length > 0
                ? track.album.images[0].url
                : null,
          })),
        );
        resolve([]);
        setSpotifyResult(null);
      })
      .catch(reject);
  });

  return (

    <>
      {writerModal && (
        <div className="z-40 top-0 left-0 fixed w-screen h-screen flex items-center justify-center bg-black bg-opacity-50">
          <div className="rounded-lg bg-white h-modal relative">
            <button
              type="button"
              onClick={() => setWriterModal(false)}
              className="absolute z-50 right-0 top-0 p-5 text-2xl"
            >
              <FaTimesCircle />
            </button>
            <div className="overflow-y-scroll h-modal p-4 lg:p-8">
              <WritersForm modal closeModal={() => setWriterModal(false)} />
            </div>
          </div>
        </div>
      )}

      <div className="flex flex-wrap">
        <div className={`w-full ${isUpdate ? 'bg-sentric-menu-gray' : 'bg-sentric-menu-gray'} lg:p-6 p-4  lg:min-h-screen-minus-header`}>
          <div className="max-w-5xl">
            <div className="max-w-3xl">
              {!spotifySuggestion
                && (
                  <H1>
                    {isUpdate ? t('songs:update-header') : t('songs:add-header')}
                    {' '}
                    {t('songs:song')}
                  </H1>
                )}
              {!isUpdate && !spotifySuggestion
                && (
                  <>
                    <Spacer thin />
                    <p>{t('songs:registering-songs-cleared-for-use-text')}</p>
                    <Spacer />
                    <ButtonPrimaryText id="btnSongFormCancel" onClick={() => history.push('/songs')}>
                      {t('songs:cancel-and-return')}
                    </ButtonPrimaryText>
                    <Spacer />
                  </>
                )}
            </div>
            <div>
              {(!id || (id && song.isSuccess && song.data !== null)) && (
                <>

                  <div className="w-full">
                    {!isUpdate && !spotifySuggestion && (
                      <>
                        <div className="bg-sentric-table-border p-4 rounded  max-w-3xl">

                          <h2 className="font-semibold text-xl">{t('songs:import-from-spotify-header')}</h2>
                          <Spacer thin />
                          <p>
                            {t('songs:import-from-spotify-text')}
                          </p>
                          <Spacer thin />
                          <div className="w-full lg:w-1/2 flex flex-row items-start justify-center text-sentric-dark-gray">
                            <Select
                              id="txtSongFormSearchSpotify"
                              debounce={500}
                              onChange={handleChangeSearchForRecords}
                              value={spotifyResult
                                ? {
                                  value: JSON.stringify(spotifyResult),
                                  name: spotifyResult.name,
                                }
                                : null}
                              getOptions={getOptionsOfRecords}
                              placeholder={t('songs:search-on-spotify-placeholder')}
                              search
                            />
                            <div id="btnSongFormSearchSpotify" className="text-white text-xl ml-4 bg-sentric-dark-gray rounded-full p-4 -mt-1">
                              <FaSearch />
                            </div>
                          </div>
                          <Spacer thin />
                          {!!spotifyResult && (
                            <>
                              <div>
                                <iframe
                                  title="preview"
                                  src={`https://open.spotify.com/embed/track/${spotifyResult.id}`}
                                  width="300"
                                  height="80"
                                  frameBorder="0"
                                  allowtransparency="true"
                                  allow="encrypted-media"
                                />
                              </div>
                              <Spacer thin />
                              <ButtonLink
                                id="btnSongFormRemoveSelection"
                                className="text-sentric-text-gray flex items-center justify-end"
                                onClick={removeSpotify}
                              >
                                <FaMinusCircle className="mr-2" />
                                {' '}
                                {t('songs:remove-selection')}
                              </ButtonLink>
                              <Spacer />

                              <Spacer thin />
                              <InnerRadio
                                name="agreeaddrecording"
                                label={t('songs:add-spotify-song-as-recording-confirm')}
                                value={agreeAddRecording}
                                onChange={(e) => setAgreeAddRecording(e.target.value)}
                                options={[
                                  { label: t('common:yes'), value: true },
                                  { label: t('common:no'), value: false },
                                ]}
                              />

                              <Spacer />

                            </>
                          )}
                        </div>
                      </>
                    )}
                    {!isUpdate && !spotifySuggestion
                      && (
                        <>
                          <Spacer />
                          <HR />
                        </>
                      )}
                    <Spacer />
                    {/* ELEMENT STARTS */}
                    <div className="w-full  max-w-xl">
                      <h2 className="font-semibold text-xl">{t('songs:song-titles-header')}</h2>
                      <Spacer thin />
                      <Input
                        id="txtSongFormTitle"
                        required
                        type="text"
                        error={errors.title}
                        placeholder={t('songs:title-placeholder')}
                        value={title}
                        onBlur={() => {
                          checkErrors('title');
                        }}
                        onChange={(e) => {
                          setTitle(e.target.value);
                        }}
                      />
                      <Spacer thin />
                      <MultipleInput
                        id="txtSongFormAltTitle"
                        name="txtSongFormAltTitle"
                        type="text"
                        addAnotherText={t('songs:add-another-title-button')}
                        error={errors.alternativetitles}
                        onBlur={() => {
                          checkErrors('alternativetitles');
                        }}
                        placeholder={t('songs:alternative-title-placeholder')}
                        valueKey="title"
                        value={alternativetitles}
                        onChange={(arr) => {
                          setAlternativetitles(arr);
                        }}
                      />
                    </div>
                    <Spacer />
                    <HR />
                    <Spacer />
                    <div className="w-full lg:w-2/3">
                      <h2 className="font-semibold text-xl">
                        {t('songs:song-details-header')}
                        {' '}
                        <span className="text-xs opacity-50">
                          (
                          {t('songs:optional')}
                          )
                        </span>
                      </h2>
                      <Spacer thin />
                      <H4>
                        {t('songs:duration')}
                        :
                      </H4>
                      <Spacer thin />
                      <div className="flex">
                        <Input
                          id="txtSongFormMin"
                          className="mr-2 w-20"
                          type="number"
                          error={errors.durationmins}
                          placeholder={t('common:mins-capital')}
                          value={durationmins}
                          onBlur={() => { }}
                          onKeyDown={(e) => {
                            if (e.keyCode === 69 || e.keyCode === 190 || e.keyCode === 110 || e.keyCode === 107
                              || e.keyCode === 187 || e.keyCode === 109 || e.keyCode === 189) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => { setDurationmins(e.target.value); }}
                          min="0"
                          max="120"
                          step="1"
                        />
                        <Input
                          id="txtSongFormSec"
                          className="w-20"
                          type="number"
                          error={errors.durationsecs}
                          placeholder={t('common:secs-capital')}
                          value={durationsecs}
                          onBlur={() => { }}
                          onKeyDown={(e) => {
                            if (e.keyCode === 69 || e.keyCode === 190 || e.keyCode === 110 || e.keyCode === 107
                              || e.keyCode === 187 || e.keyCode === 109 || e.keyCode === 189) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => { setDurationsecs(e.target.value); }}
                          min="0"
                          max="59"
                          step="1"
                        />
                      </div>
                      <Spacer />

                      <InnerRadio
                        name="isremix"
                        label={t('songs:is-this-a-remix')}
                        value={isremix}
                        onChange={(e) => setIsremix(e.target.value)}
                        options={[
                          { label: t('common:yes'), value: true },
                          { label: t('common:no'), value: false },
                        ]}
                      />

                      <Spacer />

                      <InnerRadio
                        name="containssamples"
                        label="Does this song contain samples?"
                        value={containssamples}
                        onChange={(e) => setContainssamples(e.target.value)}
                        options={[
                          { label: t('common:yes'), value: true },
                          { label: t('common:no'), value: false },
                        ]}
                      />

                    </div>

                    <Spacer />
                    <HR />
                    <Spacer />
                    <div className="w-full">
                      <h2 className="font-semibold text-xl">
                        {t('songs:writers')}
                        {' '}
                        &amp;
                        {' '}
                        {t('songs:splits')}
                      </h2>
                      <Spacer thin />

                      <div style={{ backgroundColor: '#4eb4ba' }} className="rounded-t flex flex-wrap text-white p-4">
                        <div className="lg:w-1/3 w-full">
                          <div>
                            <p className=" font-medium text-lg ">
                              {t('songs:writer-splits-assigned')}
                              :
                              <span className="font-bold ml-2">
                                {writerSplitsPercentage}
                                %
                              </span>
                            </p>
                          </div>
                          <div className="relative pt-1">
                            <div className="overflow-hidden h-2 text-xs flex rounded bg-sentric-menu-gray">
                              <div style={{ width: `${writerSplitsPercentage}%` }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-sentric-submenu-icon" />
                            </div>
                          </div>
                        </div>
                        <div className="lg:w-2/3 w-full flex justify-end lg:mb-0 mt-2">
                          <ButtonPrimary id="btnSongFormShareWriterSplit" onClick={() => shareSplitsEqually()} invert>{t('songs:share-splits-equally')}</ButtonPrimary>
                        </div>
                      </div>
                      <div className="bg-white rounded">
                        <div className="bg-sentric-table-border p-4 hidden lg:flex">
                          <div id="colWriterSplitName" className="w-4/12">
                            <p className="uppercase text-xxs font-semibold text-song-sub-color">{t('songs:writer-table-name')}</p>
                          </div>
                          <div id="colWriterSplitRole" className="w-3/12">
                            <p className="uppercase text-xxs font-semibold text-song-sub-color">{t('songs:writer-table-role')}</p>
                          </div>
                          <div id="colWriterSplitSplit" className="w-5/12">
                            <p className="uppercase text-xxs font-semibold text-song-sub-color">{t('songs:writer-table-split')}</p>
                          </div>

                        </div>
                        <Spacer thin />
                        <div className="p-4">
                          {songWriters && songWriters.map((w, i) => (
                            <SongWriterSplitCreate
                              key={w.writercode}
                              writer={w}
                              deleteSongWriter={deleteSongWriter}
                              i={i}
                              last={i === (songWriters.length - 1)}
                              setWriterField={setWriterField}
                            />
                          ))}
                        </div>
                        <div className="p-4">
                          <div className="flex flex-wrap items-center w-full">
                            <div className="lg:w-5/12 w-full lg:mb-0 mb-2">
                              {writers.isSuccess
                                && (
                                  <Select
                                    id="btnSongFormSelectWriter"
                                    className="w-full text-sentric-dark-gray"
                                    name="writer"
                                    value={selectedWriter}
                                    placeholder={t('songs:select-writer-placeholder')}
                                    onChange={(selected) => setSelectedWriter(selected)}
                                    options={writers?.data?.writers.filter((w) => !songWriters.filter((sw) => !sw.isdeleted).map((s) => s.writercode).includes(w.writercode)).map((w) => ({ name: `${w.firstname} ${(!w.middlename || w.middlename === 'null') ? '' : w.middlename} ${w.lastname} ${(!w.caeipinumber || w.caeipinumber === 'null' ? '' : w.caeipinumber)}`, value: w.writercode }))}
                                    search
                                  />
                                )}
                            </div>
                            <div className="lg:w-4 w-full lg:mb-0 mb-2" />
                            <ButtonPrimary
                              id="btnSongFormAddWriter"
                              onClick={() => {
                                if (selectedWriter) {
                                  setSongWriters([...songWriters, { writercode: selectedWriter, righttocollect: 'false' }]);
                                  setSelectedWriter(null);
                                }
                              }}
                            >
                              {t('songs:add-writer-button')}
                            </ButtonPrimary>
                            <div className="lg:w-4 w-full lg:mb-0 mb-2" />
                            <div className="flex flex-1 justify-end text-xs items-center">
                              <p className="mr-2">{t('songs:writer-not-listed')}</p>
                              <ButtonPrimaryText id="btnSongFormCreateWriter" onClick={() => setWriterModal(true)}>
                                {t('songs:create-new-writer')}
                              </ButtonPrimaryText>
                            </div>
                          </div>

                        </div>

                      </div>

                      <Spacer thin />
                      {!!errors.writers
                        && <p className="w-4/5 error-arrow-top text-sm inline-block p-1 pr-3 pl-3 bg-red-700 mt-0 mb-4 text-white rounded-lg border-white border">{errors.writers}</p>}
                      <P small>
                        <FaInfoCircle className="inline mr-2" />
                        {' '}
                        {t('songs:when-adding-writers-percentage')}
                      </P>

                    </div>
                    <Spacer />
                    <HR />
                    <Spacer />
                    <div className="w-full max-w-xl">
                      <h2 className="font-semibold text-xl">{t('songs:performing-artists')}</h2>
                      <Spacer thin />
                      <MultipleInput
                        name="txtSongFormPerformers"
                        required
                        type="text"
                        maxLength={45}
                        reset={reset}
                        error={errors.performers}
                        placeholder={t('songs:performer-placeholder')}
                        addAnotherText={t('songs:add-another-performer-button')}
                        valueKey="name"
                        value={performers}
                        onBlur={() => {
                          checkErrors('performers');
                        }}
                        onChange={(arr) => {
                          setPerformers(arr);
                        }}
                      />
                      <Spacer />

                    </div>
                    <Spacer thin />
                    <ApiErrorMessage apiError={apiError} />
                    <div className={`flex flex-wrap items-center ${spotifySuggestion ? 'justify-end' : 'justify-start'}`}>
                      <div className={`${spotifySuggestion ? 'order-2' : 'order-1'} mx-4`}>

                        {!isUpdate && (
                          <ButtonPrimaryLarge
                            id="btnSongFormAddSong"
                            onClick={addSong}
                            disabled={pending}
                            pending={pending}
                          >
                            {t('songs:add-song-button')}
                          </ButtonPrimaryLarge>
                        )}
                        {isUpdate && (
                          <ButtonPrimaryLarge
                            id="btnSongFormUpdateSong"
                            onClick={update}
                            disabled={pending || isLocked}
                            pending={pending}
                          >
                            {isLocked && (
                              <>
                                <FaLock className="inline" />
                                {' '}
                              </>
                            )}
                            {t('songs:update-song-button')}
                          </ButtonPrimaryLarge>
                        )}
                      </div>
                      <div className={`${spotifySuggestion ? 'order-1' : 'order-2'} mx-4 flex justify-center `}>
                        {!isUpdate
                          && (
                            <ButtonPrimaryText id="btnSongFormCancelReturn" onClick={() => history.push('/songs')}>
                              {spotifySuggestion ? t('songs:cancel-and-discard') : t('songs:cancel-and-return')}
                            </ButtonPrimaryText>
                          )}
                        {isUpdate
                          && (
                            <ButtonPrimaryText id="btnSongFormCancelUpdateReturn" onClick={closeModal}>
                              {t('songs:cancel-and-discard')}
                            </ButtonPrimaryText>
                          )}
                      </div>
                    </div>
                  </div>
                </>
              )}
              {id && song.isLoading && <LoadingSmall />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default SongsCreateUpdate;
